import { render, staticRenderFns } from "./FixedRentalDescription.vue?vue&type=template&id=22d2586f"
import script from "./FixedRentalDescription.vue?vue&type=script&lang=js"
export * from "./FixedRentalDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports